module.exports = __webpack_public_path__ + "img/testScreen.9d77162f.svg";